import _styled, { css as _css, default as _styled2, default as _styled3, default as _styled4, default as _styled5, default as _styled6, default as _styled7, default as _styled8 } from "styled-components";
import type { SanityCaseStudyCard } from "@ouster/shared";
import { m } from "framer-motion";
import { stripHtmlTags, takeFirst } from "~/features/app/utils";
import { hasRenderableSanityMedia, SanityMediaFigure } from "~/features/sanity/page-builder/sections/media-figure";
import { toHtml } from "~/features/sanity/rich-text/to-html";
import { Button } from "~/features/ui/button";
import { Headline } from "~/features/ui/headline";
import { IconButton } from "~/features/ui/icon-button";
import { Link } from "~/features/ui/link";
import Close from "~/public/icons/close.svg";
import ArrowRight from "~/public/icons/arrow-right.svg";
type Props = {
  caseStudy: SanityCaseStudyCard;
  onClose: () => void;
};
export function InfoWindow({
  caseStudy,
  onClose
}: Props) {
  const {
    headline,
    title,
    href,
    hero
  } = caseStudy;
  const {
    text,
    media
  } = takeFirst(hero) || {};
  const html = text?.length ? toHtml(text) : undefined;
  return <_StyledMDiv initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }}>
      <_StyledDiv>
        <_StyledIconButton icon={{
        component: Close
      }} onClick={onClose} />
        {href && hasRenderableSanityMedia(media) && <_StyledLink href={href}>
            <SanityMediaFigure media={media} ratio="5/6" showCaption={false} sizes="lg:25vw" />
          </_StyledLink>}
        <_StyledDiv2>
          {(headline || title) && <_StyledHeadline type="h2" text={headline || title || ""} />}
          {html && <_StyledP $_css2={[{
          "marginTop": "1.6rem",
          "fontSize": "1.4rem",
          "lineHeight": "1.5",
          "letterSpacing": "0.014000000000000002rem",
          "fontWeight": "400",
          "@media (min-width: 1024px)": {
            "marginTop": "0.8rem"
          }
        }, _css(["overflow:hidden;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;"])]}>
              {stripHtmlTags(html)}
            </_StyledP>}
          {href && <_StyledDiv3>
              <Button as={Link} variant="underline" icon={ArrowRight} href={href}>
                Read Case Study
              </Button>
            </_StyledDiv3>}
        </_StyledDiv2>
      </_StyledDiv>
    </_StyledMDiv>;
}
var _StyledMDiv = _styled(m.div).withConfig({
  componentId: "sc-sf-1cfucd-0"
})({
  "position": "absolute",
  "bottom": "0.8rem",
  "left": "0.8rem",
  "right": "0.8rem",
  "maxWidth": "36.4rem",
  "@media (min-width: 1024px)": {
    "bottom": "0",
    "left": "50%",
    "top": "50%",
    "--tw-translate-x": "-50%",
    "transform": "translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))",
    "--tw-translate-y": "-50%"
  }
});
var _StyledDiv = _styled2("div").withConfig({
  componentId: "sc-sf-1cfucd-1"
})({
  "position": "relative",
  "display": "flex",
  "gap": "1.6rem",
  "overflow": "hidden",
  "borderRadius": "4px",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))",
  "padding": "0.8rem"
});
var _StyledIconButton = _styled3(IconButton).withConfig({
  componentId: "sc-sf-1cfucd-2"
})({
  "position": "absolute",
  "right": "0",
  "top": "0"
});
var _StyledLink = _styled4(Link).withConfig({
  componentId: "sc-sf-1cfucd-3"
})({
  "maxWidth": "10rem",
  "overflow": "hidden",
  "borderRadius": "4px"
});
var _StyledDiv2 = _styled5("div").withConfig({
  componentId: "sc-sf-1cfucd-4"
})({
  "display": "flex",
  "width": "100%",
  "flexDirection": "column",
  "alignItems": "flex-start",
  "paddingTop": "0.8rem",
  "paddingBottom": "0.8rem"
});
var _StyledHeadline = _styled6(Headline).withConfig({
  componentId: "sc-sf-1cfucd-5"
})({
  "fontSize": "2rem",
  "lineHeight": "1.3",
  "letterSpacing": "0.02rem",
  "fontWeight": "400",
  "@media (min-width: 1024px)": {
    "fontSize": "2.4rem",
    "lineHeight": "1.3",
    "letterSpacing": "0.024rem",
    "fontWeight": "400"
  }
});
var _StyledP = _styled7("p").withConfig({
  componentId: "sc-sf-1cfucd-6"
})`${p => p.$_css2}`;
var _StyledDiv3 = /*#__PURE__*/_styled8("div").withConfig({
  displayName: "info-window___StyledDiv3",
  componentId: "sc-1idch1o-0"
})({
  "marginTop": "auto"
});